import { render, staticRenderFns } from "./edit-master.vue?vue&type=template&id=4d8bb955"
import script from "./edit-master.vue?vue&type=script&lang=js"
export * from "./edit-master.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports